import schema from './runtime-schema.json';

export function resolveRuntimeConfig(runtime, developmentEnv, production) {
  if (production && (!runtime || typeof runtime !== 'object' || Array.isArray(runtime))) {
    throw new Error('Falta /runtime-config.js. Iniciar el contenedor con las variables REACT_APP_VASLOLA_* requeridas.');
  }
  const source = production ? runtime : (runtime || developmentEnv);
  const values = {};
  const keys = [...schema.required, ...Object.keys(schema.defaults)];
  keys.forEach(key => {
    values[key] = source[key] ?? schema.defaults[key] ?? '';
    if (production && typeof values[key] !== 'string') {
      throw new Error(`Configuración inválida: ${key} debe ser un string.`);
    }
  });
  if (production) {
    schema.required.forEach(key => {
      if (!values[key].trim()) throw new Error(`Falta la variable ${key}.`);
    });
    Object.entries(schema.patterns).forEach(([key, pattern]) => {
      if (values[key] && !new RegExp(pattern).test(values[key])) {
        throw new Error(`Formato inválido para ${key}. El sitio se publica en la raíz (/).`);
      }
    });
  }
  return Object.freeze(values);
}

// CRA elimina la rama de desarrollo del bundle de producción.
const developmentEnv = process.env.NODE_ENV !== 'production' ? {
  REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL: process.env.REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL,
  REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL_BACK: process.env.REACT_APP_VASLOLA_FRONTEND_PUBLIC_URL_BACK,
  REACT_APP_VASLOLA_FRONTEND_AUTH_CLIENT_ID: process.env.REACT_APP_VASLOLA_FRONTEND_AUTH_CLIENT_ID,
  REACT_APP_VASLOLA_BASENAME: process.env.REACT_APP_VASLOLA_BASENAME,
  REACT_APP_VASLOLA_CONTACT_WHATSAPP: process.env.REACT_APP_VASLOLA_CONTACT_WHATSAPP,
  REACT_APP_VASLOLA_CONTACT_EMAIL: process.env.REACT_APP_VASLOLA_CONTACT_EMAIL,
  REACT_APP_VASLOLA_WSS_URL: process.env.REACT_APP_VASLOLA_WSS_URL,
  REACT_APP_VASLOLA_WSS_PATH: process.env.REACT_APP_VASLOLA_WSS_PATH,
  REACT_APP_VASLOLA_API_BASE_URL: process.env.REACT_APP_VASLOLA_API_BASE_URL,
  REACT_APP_VASLOLA_API_BASE_PATH: process.env.REACT_APP_VASLOLA_API_BASE_PATH,
  REACT_APP_VASLOLA_AUTH_BASE_PATH: process.env.REACT_APP_VASLOLA_AUTH_BASE_PATH,
} : {};

export default resolveRuntimeConfig(
  typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined,
  developmentEnv,
  process.env.NODE_ENV === 'production',
);
